<template>
    <div :style="{ visibility: $GlobalStore.isShowSystemPatch() ? '' : 'hidden' }" class="system_modal">
        <Transition name="fade">
            <div v-if="$GlobalStore.isShowSystemPatch()" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.4); z-index: 10;"></div>
        </Transition>
        <div class="basic_frame" :class="{ open: $GlobalStore.isShowSystemPatch() }">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <div style="font-weight: 700; font-size: 18px; margin-bottom: 15px;">사커하우 시스템 패치중</div>
                    <div>금방 처리되니 잠시만 기다려주세요</div>
                </div>
                <div>
                    <img v-if="$GlobalStore.isCompleteUpdate()" style="width: 35px;" :src="require('@/assets/img/patch_complete.png')" alt="">
                    <img v-if="!$GlobalStore.isCompleteUpdate() && $GlobalStore.isShowSystemPatch()" style="width: 35px;" :src="require('@/assets/img/patch_progress.gif')" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SystemPatch',
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.system_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    transition: all 0.5s;
}

.basic_frame {
    background-color: #fff;
    padding: 20px;
    border-radius: 24px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
    box-shadow: 0px 1px 10px 0px #210F0333;
    width: calc(100% - 40px);
}

.basic_frame.open {
    top: 80%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>